<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container modal-inner-container--small">
    <ion-row>
      <ion-col>
        <app-modal-header [header]="headerText" (close)="back()">
        </app-modal-header>
        <ion-grid fixed>
          <ion-row>
            <ion-col>
              <app-select-user
                (changeValueEvent)="setUser($event)"
                [filtrIdCompany]="filtrIdCompany"
                [removeCurrentUserFromList]="removeCurrentUserFromList"
              ></app-select-user>
              <ion-label *ngIf="noUserError" color="danger" class="font-size__16">
                {{ "REQUIRED_VALIDATION" | translate }}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="button-col">
              <ion-item class="input" lines="none">
                <ion-button
                  class="button-margin-top-md"
                  (click)="back()"
                  size="medium"
                  slot="end"
                  fill="outline"
                >
                  {{ "CANCEL" | translate }}
                </ion-button>
              </ion-item>
              <ion-item class="input" lines="none">
                <ion-button
                  class="button-margin-top-md"
                  (click)="save()"
                  size="medium"
                  slot="end"
                >
                  {{ "SAVE" | translate }}
                </ion-button>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
